import React, { useEffect, useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import JourneyList from 'modules/journey/list/List';

import { FinishedJourneyCard } from 'modules/journey/card';
import { EmptyListStyled, LoadingListStyled } from 'modules/journey/list/styled/index.js';
import { DateTitle } from 'modules/journey/card/headings';
import ScrollElementContext from 'containers/App/context';
import { openJourneyDetail } from 'redux/modules/journeys/effects';

const Finished = React.memo(
  ({
    filters,
    nextPage,
    history,
    onLoadMore,
    nextPageLoading,
    className,
    loading,
    hasError,
    grouped,
    intl,
  }) => {
    const t = intl.messages.containers.Jobs;
    const hasJourneys = !!Object.keys(grouped).length;
    const loadingJourneys = loading || nextPageLoading;
    const dispatch = useDispatch();

    const scrollElement = useContext(ScrollElementContext);

    const handleJourneyClick = useCallback(
      (id) => {
        const listScrollTop = scrollElement.current.scrollTop;

        dispatch(
          openJourneyDetail({
            id,
            fromList: 'finished',
            listScrollTop,
          })
        );
      },
      [scrollElement, dispatch]
    );

    const handleLoadMore = useCallback(() => {
      onLoadMore({ filters, nextPage });
    }, [filters, onLoadMore, nextPage]);

    useEffect(() => {
      const { action } = history;

      if (!['PUSH'].includes(action)) {
        return;
      }

      const { location } = history;

      const { listScrollTop } = (location || {}).state || {};

      scrollElement.current.scrollTop = listScrollTop;
    }, [history, scrollElement]);

    return (
      <>
        {!loading && hasJourneys && (
          <InfiniteScroll
            pageStart={0}
            loadMore={handleLoadMore}
            hasMore={!!nextPage && !nextPageLoading}
            loader={<LoadingListStyled key={0} />}
            useWindow={false}
            className={className}
          >
            <JourneyList
              grouped={grouped}
              titleComponent={DateTitle}
              loadingComponent={LoadingListStyled}
              cardComponent={FinishedJourneyCard}
              onCardClick={handleJourneyClick}
            />
          </InfiniteScroll>
        )}
        {!loading && !hasJourneys && !hasError && <EmptyListStyled>{t.no_jobs}</EmptyListStyled>}
        {hasError && <EmptyListStyled>There was a problem getting the jobs</EmptyListStyled>}
        {loadingJourneys && <LoadingListStyled />}
      </>
    );
  }
);

export default Finished;
